module.exports = __webpack_public_path__ + "img/brightness.b856e19e.svg";